import { render, staticRenderFns } from "./App.vue?vue&type=template&id=178407a5"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=178407a5&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.4.38_css-loader@6.11.0_webpack@5.94.0__handlebar_2aedba235eac052937d84807a282dc7b/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports